'use strict';

exports.__esModule = true;
exports.getLocaleAndMessages = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLocaleAndMessages = exports.getLocaleAndMessages = function getLocaleAndMessages() {
    var _$split = (typeof navigator !== 'undefined' && navigator.languages || ['en'])[0].split('-'),
        locale = _$split[0];

    var defaultMessages = require('../../src/lang/en.json');
    var messages = void 0;
    try {
        var localeMessages = require('../../src/lang/' + locale + '.json');
        messages = (0, _extends3.default)({}, defaultMessages, localeMessages);
    } catch (error) {
        messages = defaultMessages;
    }
    return {
        locale: locale,
        messages: messages
    };
};